import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import Redirect from '@swf/components/Redirect/Redirect';
import { Vary } from '@swf/components/ResponseHeaders/ResponseHeaders';
import { Header } from '@swf/core/enums';
import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';
import { Message, TryAgainMessage } from '@swf/sports/components';
import SpecialsTemplatePanel from '@swf/sports/components/SpecialsTemplatePanel/SpecialsTemplatePanel';
import useMarketUpdates from '@swf/sports/hooks/useMarketUpdates';
import { EventTypeId } from '@swf/sports/types/eventType';

import { TXTWCL_There_are_currently_no_special_ELL } from './SportsEventTypeSpecialsWidget.messages.json';
import { sportsEventTypeSpecialsWidgetModel, useSportsEventTypeSpecialsWidget } from './model';

const SportsEventTypeSpecialsWidget: WidgetFC = () => {
  const { widgetSelect, widgetDispatch } = useSportsEventTypeSpecialsWidget();
  const templateGroups = useSelector(widgetSelect.templateGroups);
  const errorCode = useSelector(widgetSelect.errorCode);
  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);
  const marketIds = useSelector(widgetSelect.marketIds);
  const { eventTypeId, eventTypeSlug } = useSelector(select.sports.getUrlParams);

  useMarketUpdates(marketIds, widgetDispatch.marketsUpdated);

  if (eventTypeId !== String(EventTypeId.SOCCER)) {
    return <Redirect alias="sportsSport" values={{ eventTypeId, eventTypeSlug }} />;
  }

  if (hasPreloaded) {
    if (errorCode === 404 || (!errorCode && !templateGroups.length))
      return <Message message={<Translation {...TXTWCL_There_are_currently_no_special_ELL} />} />;
    if (errorCode) {
      return <TryAgainMessage />;
    }
  }

  return (
    <>
      <Vary by={[Header.TimeZone]} />
      {templateGroups.map((panel, panelIndex) => (
        <SpecialsTemplatePanel
          isFirstPanel={panelIndex === 0}
          panel={panel}
          key={`panel-${panelIndex}`}
        />
      ))}
    </>
  );
};

SportsEventTypeSpecialsWidget.model = sportsEventTypeSpecialsWidgetModel;

export default SportsEventTypeSpecialsWidget;
